import React from 'react';
import { useDelete } from '../graphql/hooks';
import Loading from '../teal-react/components/molecules/Loading';
import SimpleTable from '../teal-react/components/organisms/SimpleTable';
import { IconButton } from '@mui/material';
import { DeleteOutline, EditOutlined } from '@mui/icons-material';
import SimpleDeleteConfirm from '../teal-react/components/organisms/SimpleDeleteConfirm';
import SimpleModal from '../teal-react/components/organisms/SimpleModal';
import BatchMaterialForm from './BatchMaterialForm';
import { useBatchMaterials } from '../graphql/queries';
// import { Api, Utils } from '@jesseteal/teal-react'

interface BatchMaterialsEditorProps {
  batch_id: number;
}
const BatchMaterialsEditor = ({ batch_id }: BatchMaterialsEditorProps) => {
  const [deleteId, setDeleteId] = React.useState(0);
  const [selected, setSelected] = React.useState<any>();
  const deleteMat = useDelete('batch_material', ['batch', 'qc']);
  const { data } = useBatchMaterials(batch_id);
  if (!data) {
    return <Loading />;
  }

  const batch = data.batch[0];
  return (
    <>
      <SimpleTable
        noCard
        data={batch.materials}
        row_limit={9999}
        actionsLeft={[
          {
            label: 'Add Material',
            onClick: () => {
              setSelected({
                batch_id,
                ordinal: batch.materials.length + 1,
              });
            },
          },
        ]}
        columns={[
          // {
          //   header: '#',
          //   cell: 'ordinal',
          //   style: { width: 40 },
          //   align: 'right',
          // },
          {
            header: 'Material',
            cell: (r: any) => r.material,
          },

          {
            header: 'Amount',
            cell: (r: any) => `${r.amount || ''} ${r.unit?.name || ''}`,
            align: 'right',
          },
          { header: 'Remark' },
          {
            header: '',
            sort: false,
            cell: (r: any) => (
              <span>
                <IconButton onClick={() => setSelected(r)}>
                  <EditOutlined color="primary" />
                </IconButton>
                <IconButton
                  onClick={() => {
                    setDeleteId(r.id);
                  }}
                >
                  <DeleteOutline color="error" />
                </IconButton>
              </span>
            ),
          },
        ]}
      />
      {deleteId ? (
        <SimpleDeleteConfirm
          onCancel={() => setDeleteId(0)}
          onDelete={() => {
            deleteMat({ id: deleteId });
            setDeleteId(0);
          }}
        />
      ) : null}
      {selected ? (
        <SimpleModal open={true} size="md">
          <BatchMaterialForm
            model={selected}
            onClose={() => setSelected(null)}
          />
        </SimpleModal>
      ) : null}
    </>
  );
};

export default BatchMaterialsEditor;
